__turbopack_context__.v({
  "actions": "Modal-module__dPZ85W__actions",
  "body": "Modal-module__dPZ85W__body",
  "closeBtn": "Modal-module__dPZ85W__closeBtn",
  "fadeIn": "Modal-module__dPZ85W__fadeIn",
  "footer": "Modal-module__dPZ85W__footer",
  "header": "Modal-module__dPZ85W__header",
  "headerDanger": "Modal-module__dPZ85W__headerDanger",
  "modal": "Modal-module__dPZ85W__modal",
  "overlay": "Modal-module__dPZ85W__overlay",
  "slideIn": "Modal-module__dPZ85W__slideIn",
  "title": "Modal-module__dPZ85W__title",
});
